import { useParams } from 'react-router-dom'
import CapabilityLevelCard from '../components/CapabilityLevelCard'
import Callout from '../components/Callout'
import DataRequirementsTable from '../components/DataRequirementsTable'
import HomeContent from '../../../../src/components/SectionContent'
import SectionHeading from '../components/SectionHeading'
import { USE_CASES_MAP } from '../config/useCases.config'
import type { UseCaseId } from '../types'

const UseCasesDataNeeds = () => {
  const { useCaseId } = useParams<{ useCaseId: UseCaseId }>()
  const useCase = useCaseId ? USE_CASES_MAP[useCaseId] : null

  if (!useCase) return <div>Use case not found: {useCaseId}</div>

  const { dataNeedsIntro, capabilityLevels, dataRequirements, accentColor } = useCase

  return (
    <div className="flex flex-col">
      <HomeContent className="py-8">
        <p className="text-base leading-relaxed text-foreground">{dataNeedsIntro}</p>
      </HomeContent>

      <HomeContent className="pb-10">
        <SectionHeading className="mb-4">Levels of capability</SectionHeading>
        <div className="grid grid-cols-2 gap-0 overflow-hidden rounded-lg lg:grid-cols-4">
          {capabilityLevels.map((level, i) => (
            <CapabilityLevelCard
              key={level.level}
              level={level}
              accentColor={accentColor}
              index={i}
              isFirst={i === 0}
              isLast={i === capabilityLevels.length - 1}
            />
          ))}
        </div>
      </HomeContent>

      <HomeContent className="pb-12">
        <SectionHeading className="mb-4">Minimum data by capability level</SectionHeading>
        <DataRequirementsTable rows={dataRequirements} accentColor={accentColor} />
      </HomeContent>

      <HomeContent className="pb-12">
        <Callout
          title="Not sure where to start?"
          description="Our team can help you assess your current data, identify gaps, and co-develop a roadmap to build capability over time."
          actionLabel="Get in touch"
          onActionClick={() =>
            window.open('https://resilience-explorer.com/contact', '_blank', 'noopener,noreferrer')
          }
        />
      </HomeContent>
    </div>
  )
}

export default UseCasesDataNeeds
